// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Subscription V5 */
.BC-SubscriptionV5_NotifyBanner {
  display: flex;
  gap: 4px;
  border-radius: 8px;
  padding: 6px 8px 6px 4px;
  align-items: start;
  margin-bottom: 20px;
}

.BC-SubscriptionV5_NotifyBanner .text {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  align-items: center;
  margin: auto 0;
}

.BC-SubscriptionV5_NotifyBanner > img {
  padding: 3px;
}

.BC-SubscriptionV5_NotifyBanner .close-btn {
  margin: auto;
  margin-right: 4px;
  width: 16px;
  height: 16px;
}

.BC-SubscriptionV5_NotifyBanner .Polaris-Button__Content,
.BC-SubscriptionV5_NotifyBanner .Polaris-Icon {
  width: 11px;
  height: 11px;
}

.BC-SubscriptionV5_NotifyInfo {
  background: #e0f0ff;
}

.BC-SubscriptionV5_NotifySuccess {
  background: #cdfee1;
}

.BC-SubscriptionV5_NotifyInfo .text {
  color: #00527c;
}

.BC-SubscriptionV5_NotifySuccess .text {
  color: #0c5132;
}

.BC-SubscriptionV5_NotifySuccess > img {
  filter: brightness(0) saturate(100%) invert(39%) sepia(83%) saturate(353%) hue-rotate(101deg)
    brightness(95%) contrast(92%);
}

.BC-SubscriptionV5_NotifyInfo .action {
  color: #00527c;
  text-decoration: underline;
  cursor: pointer;
}

.BC-SubscriptionV5_BillingPackage,
.BC-SubscriptionV5_BillingInformation {
  display: flex;
  gap: 20px;
}

.BC-SubscriptionV5_BillingPackage > div,
.BC-SubscriptionV5_BillingInformation > div {
  padding: 20px;
  border-radius: 8px;
  width: 50%;
}

.BC-SubscriptionV5_BillingInformation > div:nth-child(2) {
  background-color: #fafbfb;
}

.BC-SubscriptionV5_BillingInformation .plan-status {
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 25px;
}

.BC-SubscriptionV5_BillingPackage .plan-status .description,
.BC-SubscriptionV5_BillingInformation .plan-status .description {
  font-size: 14px;
  margin-top: 8px;
}

.BC-SubscriptionV5_BillingPackage .plan-status.trial .selected .Polaris-Badge span,
.BC-SubscriptionV5_BillingPackage .plan-status.trial .description,
.BC-SubscriptionV5_BillingInformation .plan-status.trial .selected .Polaris-Badge span,
.BC-SubscriptionV5_BillingInformation .plan-status.trial .description {
  color: #5e4200;
  font-weight: 500;
}

.BC-SubscriptionV5_BillingPackage .plan-status .Polaris-Badge--statusCritical,
.BC-SubscriptionV5_BillingPackage .plan-status.expired .description,
.BC-SubscriptionV5_BillingPackage .plan-status.exceeded .description,
.BC-SubscriptionV5_BillingInformation .plan-status .Polaris-Badge--statusCritical,
.BC-SubscriptionV5_BillingInformation .plan-status.expired .description,
.BC-SubscriptionV5_BillingInformation .plan-status.exceeded .description {
  color: #8e1f0b;
  font-weight: 500;
}

.BC-SubscriptionV5_BillingPackage .plan-status .selected,
.BC-SubscriptionV5_BillingInformation .plan-status .selected {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-top: 10px;
}

.BC-SubscriptionV5_BillingPackage .plan-status .selected > p,
.BC-SubscriptionV5_BillingInformation .plan-status .selected > p {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
}

.BC-SubscriptionV5_BillingPackage .plan-status .selected .Polaris-Badge,
.BC-SubscriptionV5_BillingInformation .plan-status .selected .Polaris-Badge {
  border-radius: 8px;
  padding: 2px 8px;
  height: 20px;
}

.BC-SubscriptionV5_BillingPackage .plan-status .Polaris-Badge--statusWarning,
.BC-SubscriptionV5_BillingInformation .plan-status .Polaris-Badge--statusWarning {
  background-color: #ffea8a;
  color: #4f4700;
}

.BC-SubscriptionV5_BillingPackage .plan-status .Polaris-Badge span,
.BC-SubscriptionV5_BillingInformation .plan-status .Polaris-Badge span {
  font-weight: 500;
}

.BC-SubscriptionV5_BillingPackage .plan-status .Polaris-Badge--statusSuccess,
.BC-SubscriptionV5_BillingInformation .plan-status .Polaris-Badge--statusSuccess {
  background-color: #cdfee1;
  color: #0c5132;
}

.BC-SubscriptionV5_BillingInformation .info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.BC-SubscriptionV5_BillingInformation .info .billing-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.BC-SubscriptionV5_BillingInformation .info .billing-header .management .Polaris-Icon span,
.BC-SubscriptionV5_BillingInformation .info .billing-header .management .Polaris-Icon {
  margin: unset;
  width: 16px;
  height: 16px;
}

.BC-SubscriptionV5_BillingInformation .info .billing-header .management {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #2c6ecb;
  font-weight: 400;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
}

.BC-SubscriptionV5_BillingInformation .info .list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px; /* Gap between items */
}

.BC-SubscriptionV5_BillingInformation .info .list .item {
  flex: 0 0 calc((100% - 12px) / 2); /* Allow exactly 3 items in a row, accounting for gaps */
  gap: 4px;
}

.BC-SubscriptionV5_BillingInformation .info .list .item.underline > span {
  border-bottom: 3px dotted #dfe3e8;
}

.BC-SubscriptionV5_BillingInformation .info .list .item > span {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #202223;
}

.BC-SubscriptionV5_BillingInformation .info .list .item > p {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin: 4px 0;
}

/* GMV detail modal */
.BC-SubscriptionV5_GMVDetailModal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.BC-SubscriptionV5_GMVDetailModal .gmv-table {
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.BC-SubscriptionV5_GMVDetailModal .gmv-table .gmv-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.BC-SubscriptionV5_GMVDetailModal .gmv-table .heading {
  background-color: #fafbfb;
  font-weight: 600;
}

.BC-SubscriptionV5_GMVDetailModal .gmv-table .gmv-row:not(:last-child) {
  border-bottom: 1px solid #e1e3e5;
}

.BC-SubscriptionV5_GMVDetailModal .gmv-table .gmv-row:last-child {
  background-color: #f1f8f5;
}

.BC-SubscriptionV5_GMVDetailModal .gmv-table .footer .total > p {
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #005e46;
}

/* Container spacing */
.BC-SubscriptionV5_ExplorePackages .slider-container {
  position: relative;
  width: 100%;
  padding: 12px 20px;
  border-radius: 8px;
  background-color: #fafafa;
}

.BC-SubscriptionV5_ExplorePackages .slider-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

/* Wrap the slider for positioning tooltip */
.BC-SubscriptionV5_ExplorePackages .slider-wrapper {
  position: relative;
}

/* Tooltip styling */
.BC-SubscriptionV5_ExplorePackages .slider-tooltip {
  position: absolute;
  top: 20px;
  transform: translateX(-50%);
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px #0000001a;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 6px;
  white-space: nowrap;
}

/* Labels under slider */
.BC-SubscriptionV5_ExplorePackages .slider-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  font-size: 13px;
  color: #6b7280; /* gray-500 */
}

/* make the track thick and square, using Polaris variables (we set them inline in the wrapper) */
.BC-SubscriptionV5_ExplorePackages .slider-container .Polaris-RangeSlider-SingleThumb__Input {
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: transparent;
  -webkit-appearance: none;
  appearance: none;
  position: relative;
  z-index: 1;
  background: #e1e3e5;
  border-radius: 4px;
  /* override track height & border-radius */
  height: 6px !important; /* thick track */
  overflow: visible;
  background-repeat: no-repeat;
  --pc-single-thumb-progress-lower: #008060;
  --pc-single-thumb-progress-upper: transparent;
  --pc-single-thumb-gradient-colors: var(--pc-single-thumb-progress-lower) 0%,
    var(--pc-single-thumb-progress-lower) var(--pc-range-slider-progress),
    var(--pc-single-thumb-progress-upper) var(--pc-range-slider-progress),
    var(--pc-single-thumb-progress-upper) 100%;
}

/* Thumb element (Polaris separate element) */
.BC-SubscriptionV5_ExplorePackages .slider-container .Polaris-RangeSlider-SingleThumb__Thumb {
  background-color: #008060 !important;
  border: 2px solid var(--pc-single-thumb-progress-lower) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12) !important;
}

/* Make sure the focus ring looks nice */
.BC-SubscriptionV5_ExplorePackages .slider-container .Polaris-RangeSlider-SingleThumb__Input:focus {
  outline: none;
}

/* Firefox (sometimes needs -moz) */
.BC-SubscriptionV5_ExplorePackages
  .slider-container
  .Polaris-RangeSlider-SingleThumb__Input::-moz-range-track {
  height: 6px;
  background: linear-gradient(
    90deg,
    var(--pc-single-thumb-progress-lower) 0%,
    var(--pc-single-thumb-progress-lower) var(--pc-range-slider-progress),
    var(--pc-single-thumb-progress-upper) var(--pc-range-slider-progress),
    var(--pc-single-thumb-progress-upper) 100%
  );
}

/* WebKit track fallback */
.BC-SubscriptionV5_ExplorePackages
  .slider-container
  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-runnable-track {
  height: 6px;
  background: linear-gradient(
    90deg,
    var(--pc-single-thumb-progress-lower) 0%,
    var(--pc-single-thumb-progress-lower) var(--pc-range-slider-progress),
    var(--pc-single-thumb-progress-upper) var(--pc-range-slider-progress),
    var(--pc-single-thumb-progress-upper) 100%
  );
}

/* WebKit thumb fallback (if Polaris structure differs) */
.BC-SubscriptionV5_ExplorePackages
  .slider-container
  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {
  -webkit-appearance: none;
  background: #008060;
  border: 2px solid var(--pc-single-thumb-progress-lower);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.BC-SubscriptionV5_ExplorePackages .package-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
}

.BC-SubscriptionV5_ExplorePackages .package-header > div {
  width: 50%;
}

.BC-SubscriptionV5_ExplorePackages .slider-header .Polaris-TextStyle--variationStrong {
  font-weight: 500;
}

.BC-SubscriptionV5_ExplorePackages .slider-header .Polaris-TextStyle--variationPositive {
  font-weight: 600;
  color: #008060;
  font-size: 16px;
}

/* Packages card */
.BC-SubscriptionV5_ExplorePackages .packages {
  display: flex;
  gap: 16px;
  margin-top: 40px;
  align-items: stretch;
}

.BC-SubscriptionV5_ExplorePackages .enterprise_only {
  background: #28a2b60d;
  border-radius: 12px;
  margin-top: 20px;
  padding: 20px;
}

.BC-SubscriptionV5_ExplorePackages .packages > div {
  flex: 1;
  border-radius: 12px;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card,
.BC-SubscriptionV5_ExplorePackages .packages .package-card {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card,
.BC-SubscriptionV5_ExplorePackages .package-highlight-card,
.BC-SubscriptionV5_ExplorePackages .recommended-card {
  border: 1px solid #00a47c;
  position: relative;
}

.BC-SubscriptionV5_ExplorePackages .package-card .info {
  padding: 56px 20px 20px;
}

.BC-Page__Package-ComparisonV5 .package-comparison-table .current-plan,
.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-highlight-card .info,
.BC-SubscriptionV5_ExplorePackages .package-highlight-card .info {
  background: linear-gradient(
    183.25deg,
    rgba(40, 162, 182, 0.18) 2.69%,
    rgba(76, 184, 121, 0) 97.31%
  );
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-highlight-card .tag,
.BC-SubscriptionV5_ExplorePackages .package-highlight-card .tag {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ffffff;
  color: #005e46;
  padding: 2px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.BC-SubscriptionV5_ExplorePackages .recommended-card .tag {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(234.15deg, #008060 -7.36%, rgba(0, 128, 96, 0) 190.52%);
  color: #ffffff;
  padding: 2px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .package-name,
.BC-SubscriptionV5_ExplorePackages .package-card .package-name {
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .price,
.BC-SubscriptionV5_ExplorePackages .package-card .price {
  font-weight: 600;
  font-size: 32px;
  line-height: 44px;
  text-align: center;
  display: flex;
  margin-top: 10px;
  justify-content: center;
}

.BC-SubscriptionV5-DowngradeInfoModal
  .downgrade-compare-container
  .package-card
  .price
  .price-number,
.BC-SubscriptionV5_ExplorePackages .package-card .price .price-number {
  font-size: 44px;
  line-height: 56px;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .price .per-month,
.BC-SubscriptionV5_ExplorePackages .package-card .price .per-month {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: end;
}

.BC-SubscriptionV5_ExplorePackages .package-card .price.disabled {
  color: #8c9196;
}

.BC-SubscriptionV5_ExplorePackages .package-card .select-product {
  text-align: center;
  margin-top: 10px;
}

.BC-SubscriptionV5_ExplorePackages .packages .only-image img {
  width: 100%;
  height: auto;
}

.BC-SubscriptionV5_ExplorePackages .package-card .Polaris-Button {
  width: 100%;
  margin-top: 24px;
}
.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .advances-package,
.BC-SubscriptionV5_ExplorePackages .package-card .advances-package {
  padding: 16px 20px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .advances-package > div,
.BC-SubscriptionV5_ExplorePackages .package-card .advances-package > div {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .advances-package .line,
.BC-SubscriptionV5_ExplorePackages .package-card .advances-package .line {
  display: flex;
  align-items: center;
  gap: 6px;
}

.BC-SubscriptionV5_ExplorePackages .package-card .advances-package .line img {
  filter: brightness(0) saturate(100%) invert(28%) sepia(94%) saturate(546%) hue-rotate(116deg)
    brightness(95%) contrast(96%);
}
.BC-SubscriptionV5_ExplorePackages .package-card .explore {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-top: 1px solid var(--Colors-Border-border-secondary, #eaecf0);
}

.BC-SubscriptionV5_ExplorePackages .package-card .explore:hover {
  cursor: pointer;
}

.BC-SubscriptionV5_ExplorePackages .package-card .explore .Polaris-Icon {
  margin: unset;
  width: 16px;
  height: 16px;
}

.BC-SubscriptionV5_ExplorePackages .package-card .explore > span {
  font-weight: 500;
}

.BC-SubscriptionV5_ExplorePackages .enterprise-package-card {
  background: linear-gradient(180deg, rgba(145, 233, 219, 0.1) 0%, rgba(140, 201, 234, 0.01) 100%);
}

.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .image {
  padding: 24px 11px 20px;
}
.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .image img {
  width: 100%;
  height: auto;
  max-width: 418px;
}

.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .info {
  padding: 0 32px 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .need-more {
  font-size: 12px;
  font-weight: 600;
}

.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .label {
  font-weight: 600;
  font-size: 26px;
  line-height: 34px;
  margin: 8px 0 4px;
}

.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .description {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .Polaris-Button {
  width: 100%;
}

/* Brands that trust us + FAQs */
.BC-SubscriptionV5_Brands {
  padding: 32px 50px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.BC-SubscriptionV5-FAQs {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px 20px;
}

.BC-SubscriptionV5-FAQs .Polaris-Layout__Section--oneHalf {
  flex: 1 1 24px;
}

.BC-SubscriptionV5-FAQs > .align-center,
.BC-SubscriptionV5_Brands .align-center {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 600px;
  margin: auto;
}

.BC-SubscriptionV5-FAQs > .align-center .Polaris-Heading,
.BC-SubscriptionV5_Brands .Polaris-Heading {
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  margin: 8px 0 4px;
}

.BC-SubscriptionV5_Brands .brand-items {
  display: flex;
  justify-content: space-around;
  gap: 40px;
}

.BC-SubscriptionV5_Brands .brand-items img {
  filter: brightness(0) drop-shadow(0 0 0.1px black);
}

.BC-SubscriptionV5_Brands .brand-items:nth-child(2) {
  margin: 20px 50px;
}

.BC-SubscriptionV5-FAQs .Polaris-Stack__Item:first-child {
  margin: unset;
  padding: 20px;
}

.BC-SubscriptionV5-FAQs .Polaris-Stack__Item:nth-child(2) {
  margin: unset;
}

.BC-SubscriptionV5-FAQs .Polaris-Stack__Item .BC_Card-Header {
  max-width: 380px;
  font-weight: 600;
}

.BC-SubscriptionV5-FAQs .Polaris-Card__Section:last-child {
  padding-top: 0px;
}

.BC-SubscriptionV5-FAQs .Polaris-Card__Section ul {
  margin: unset;
  padding-left: 20px;
}

.BC-SubscriptionV5-FAQs .Polaris-Card__Header {
  padding: var(--p-space-4) var(--p-space-4) 0;
}
/* End - Brands that trust us + FAQs */

.BC-SubscriptionV5-DowngradeInfoModal .description {
  padding-bottom: 20px;
}
.BC-SubscriptionV5-DowngradeInfoModal .description ul {
  margin: unset;
  padding-left: 21px;
}
.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container {
  display: flex;
  gap: 20px;
}
.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container > div {
  flex: 1;
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .right {
  border: 1px solid #e1e3e5;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .right .tag {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #f1f2f3;
  padding: 2px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .info {
  padding: 46px 20px 10px;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .right .info {
  background: linear-gradient(
    183.25deg,
    rgba(223, 227, 232, 0.18) 2.69%,
    rgba(223, 227, 232, 0) 97.31%
  );
}

.Polaris-Modal-Dialog__Modal:has(.BC-SubscriptionV5-DowngradeInfoModal) {
  max-width: 44rem;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .features {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .feature .item {
  display: flex;
  flex-direction: column;
}

.BC-SubscriptionV5-DowngradeInfoModal
  .downgrade-compare-container
  .package-card
  .features
  .item
  > div {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin-left: 4px;
  margin-top: 8px;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .action {
  width: 100%;
  padding: 20px;
  margin-top: auto;
}

.BC-SubscriptionV5-DowngradeInfoModal
  .downgrade-compare-container
  .package-card
  .action
  .Polaris-Button {
  width: 100%;
}

.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .select-product {
  text-align: center;
  margin: 8px auto;
}
/* Subscribe Modal */

.BC-SubscriptionV5_SubscribeModal > .description {
  padding-bottom: 16px;
}

.BC-SubscriptionV5_SubscribeModal .base-gmv {
  display: flex;
  align-items: start;
  gap: 6px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e1e3e5;
  margin-bottom: 16px;
}

.BC-SubscriptionV5_SubscribeModal .base-gmv img {
  width: 20px;
  height: 20px;
}
.BC-SubscriptionV5_SubscribeModal .base-gmv .content > p:first-child {
  font-weight: 600;
  font-size: 16px;
}

.BC-SubscriptionV5_SubscribeModal .table-package-container {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  gap: 20px;
  padding: 16px;
  border: 1px solid #e1e3e5;
  background-color: #fafbfb;
}

.BC-SubscriptionV5_SubscribeModal .table-package-container .row {
  display: flex;
  justify-content: space-between;
}

.BC-SubscriptionV5_SubscribeModal .table-package-container .row:nth-child(2) {
  cursor: pointer;
}

.BC-SubscriptionV5_SubscribeModal .row > div:first-child {
  width: 100%;
}

.BC-SubscriptionV5_SubscribeModal .row:not(:last-child) {
  border-bottom: 1px dashed #c9cccf;
  padding-bottom: 20px;
}

.BC-SubscriptionV5_SubscribeModal .discount-code-info .Polaris-TextStyle--variationPositive,
.BC-SubscriptionV5_SubscribeModal .row:not(:last-child) > div:nth-child(2) {
  font-weight: 600;
}

.BC-SubscriptionV5_SubscribeModal .row:last-child {
  align-items: center;
}

.BC-SubscriptionV5_SubscribeModal .row:last-child > div:last-child {
  font-size: 20px;
  font-weight: 700;
  color: #003d2c;
}

.BC-SubscriptionV5_SubscribeModal .table-package-container .label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.BC-SubscriptionV5_SubscribeModal .table-package-container .label > p {
  font-size: 16px;
  font-weight: 600;
}

.BC-SubscriptionV5_SubscribeModal .table-package-container .label img {
  width: 20px;
  height: 20px;
}

.BC-SubscriptionV5_SubscribeModal .table-package-container .info {
  margin-top: 10px;
  margin-left: 26px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.BC-SubscriptionV5_SubscribeModal .table-package-container .info > div {
  display: flex;
}

.BC-SubscriptionV5_SubscribeModal .table-package-container .info > div .Polaris-Connected {
  width: 345px;
}

.BC-SubscriptionV5_SubscribeModal .table-package-container .info > div > span:first-child {
  color: #6d7175;
  min-width: 82px;
}

.BC-SubscriptionV5_SubscribeModal .discount-code-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-right: -20px;
}

.BC-SubscriptionV5_SubscribeModal .discount-code-info > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.BC-SubscriptionV5_SubscribeModal .discount-code-info .code-value {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f1f8f5;
  border-radius: 4px;
  padding: 4px 8px;
}

.BC-SubscriptionV5_SubscribeModal .discount-code-info .code-value .Polaris-Icon {
  width: 14px;
  height: 14px;
  display: flex;
}

.BC-SubscriptionV5_SubscribeModal .discount-code-info .code-value .Polaris-Button__Icon {
  display: flex;
  justify-content: center;
}

/* Package Comparison */
.BC-Page__Package-ComparisonV5 .package-comparison-table {
  margin-top: 32px;
}

.BC-Page__Package-ComparisonV5 .title-bar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  font-size: 26px;
  line-height: 32px;
}

.BC-Page__Package-ComparisonV5 .choose-product-number {
  font-size: 20px;
}
.BC-Page__Package-ComparisonV5 .choose-product-number .select-product {
  margin: 0 auto;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.BC-Page__Package-ComparisonV5 .choose-product-number .select-product .Polaris-Select {
  width: 150px;
}
.BC-Page__Package-ComparisonV5 .Polaris-Heading {
  font-size: 36px;
  font-weight: 600;
  line-height: 44px;
  margin: 40px auto;
}

.BC-Page__Package-ComparisonV5 .package-comparison-table .price > span:first-child {
  font-size: 36px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  text-align: center;
}

.BC-Page__Package-ComparisonV5 .package-comparison-table .current-plan .tag {
  background-color: #ffffff;
  color: #005e46;
  padding: 2px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.BC-Page__Package-ComparisonV5 .package-comparison-table .package-name {
  margin-top: 24px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
}

.BC-Page__Package-ComparisonV5 .row-header .column-package {
  padding: 20px !important;
  gap: 0px !important;
}

.BC-Page__Package-ComparisonV5 .row-header .column-package > div:first-child {
  min-height: 20px;
  max-width: 113px;
  margin: auto;
}

.BC-Page__Package-ComparisonV5 .row-header .column-package .price {
  display: flex;
  justify-content: center;
  margin-top: 2px;
}

.BC-Page__Package-ComparisonV5 .row-header .column-package .price .per-month {
  align-items: end;
  display: flex;
  font-size: 16px;
  font-weight: 600;
}

.BC-Page__Package-ComparisonV5 .package-comparison-table .feature-collapse .action-collapse {
  font-size: 16px;
  line-height: 24px;
  padding: 10px 24px;
}

.BC-Page__Package-ComparisonV5 .package-comparison-table .feature-collapse .action-collapse img {
  width: 24px;
  height: 24px;
}

/* GMV - Billing History */
.BC-SubscriptionV5_GMVBillingHistory .BC-Page--heading > div,
.BC-SubscriptionV5_GMVBillingHistory .BC-Page--heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.BC-SubscriptionV5_GMVBillingHistory .BC-Page--heading .filter-days .Polaris-Button {
  background-color: #ffffff;
}

.BC-SubscriptionV5_GMVBillingHistory .gmv-history-table .Polaris-Card__Section {
  padding: unset;
}

.BC-SubscriptionV5_GMVBillingHistory .gmv-history-table .no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 80px;
}

.BC-SubscriptionV5_GMVBillingHistory .gmv-history-table tr th .Polaris-Labelled__LabelWrapper {
  margin-bottom: 0;
}

.BC-SubscriptionV5_GMVBillingHistory .Polaris-DataTable__Cell--header p,
.BC-SubscriptionV5_GMVBillingHistory .Polaris-DataTable__Cell--header span {
  font-weight: 600;
}

.BC-SubscriptionV5_GMVBillingHistory .Polaris-DataTable__Cell--header .Polaris-Icon {
  width: 10px;
  height: auto;
}

.BC-SubscriptionV5_GMVBillingHistory
  .Polaris-DataTable__Cell--header
  .Polaris-Tooltip-TooltipOverlay__Content {
  font-weight: 400;
  text-align: left;
}

.BC-SubscriptionV5_GMVBillingHistory .Polaris-Page {
  max-width: 1150px;
}
/* .BC-SubscriptionV5_GMVBillingHistory .pagination {
  display: flex;
  justify-content: center;
} */

.BC-SubscriptionV5_GMVBillingHistory .pagination .action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
}

.BC-SubscriptionV5_GMVBillingHistory .pagination .action .Polaris-Button:first-child {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.BC-SubscriptionV5_GMVBillingHistory .pagination .action .Polaris-Button:last-child {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.BC-SubscriptionV5_GMVBillingHistory .BC-GuideBanner__Content > div {
  display: flex;
  flex-direction: column;
  padding: 6px 0;
}

.BC-SubscriptionV5_GMVBillingHistory .BC-GuideBanner__Content .BC-GuideBanner__Actions {
  margin-top: auto;
}

.BC-Page__PackageSubscriptionV5 .package-layout {
  max-width: 936px;
  margin: 0 auto;
}

.BC-Page__PackageSubscriptionV5 .heading {
  margin-top: 40px;
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  justify-content: center;
  width: 100%;
}

.BC-Page__PackageSubscriptionV5 .heading h1 {
  font-size: 26px;
  font-weight: 600;
  line-height: 32px;
}

.BC-Page__PackageSubscriptionV5 .heading p {
  color: #6d7175;
}

.BC-Page__PackageSubscriptionV5 .Polaris-Layout__Section--oneHalf {
  flex: 1 1 24px;
}

.BC-SubscriptionV5_BillingPackage .info {
  background-color: #fafbfb;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.BC-SubscriptionV5_BillingPackage .info .billing-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.BC-SubscriptionV5_BillingPackage .info .billing-header > span {
  border-bottom: 3px dotted #dfe3e8;
}

.BC-SubscriptionV5_BillingPackage .info .gmv {
  font-size: 28px;
  line-height: 32px;
  font-weight: 600;
}
.BC-Page__PackageSubscriptionV5 .package-layout > .Polaris-Layout > .Polaris-Layout__Section {
  margin-top: 32px;
}

.BC-Page__PackageSubscriptionV5 .BC-SubscriptionV5-FAQs > .align-center .Polaris-Heading {
  margin-top: unset;
}
`, "",{"version":3,"sources":["webpack://./src/styles/subscription-v5.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;iCAC+B;AACjC;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS,EAAE,sBAAsB;AACnC;;AAEA;EACE,iCAAiC,EAAE,wDAAwD;EAC3F,QAAQ;AACV;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,cAAc,EAAE,aAAa;AAC/B;;AAEA,iGAAiG;AACjG;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,sBAAsB,EAAE,gBAAgB;EACxC,iBAAiB;EACjB,4BAA4B;EAC5B,yCAAyC;EACzC,6CAA6C;EAC7C;;;8CAG4C;AAC9C;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC;EACpC,kEAAkE;EAClE,oDAAoD;AACtD;;AAEA,wCAAwC;AACxC;EACE,aAAa;AACf;;AAEA,mCAAmC;AACnC;;;EAGE,WAAW;EACX;;;;;;GAMC;AACH;;AAEA,0BAA0B;AAC1B;;;EAGE,WAAW;EACX;;;;;;GAMC;AACH;;AAEA,yDAAyD;AACzD;;;EAGE,wBAAwB;EACxB,mBAAmB;EACnB,uDAAuD;EACvD,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE;;;;GAIC;AACH;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,mFAAmF;EACnF,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;EAME,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;iCAC+B;AACjC;AACA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,oEAAoE;AACtE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gGAAgG;AAClG;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;AACA,sCAAsC;;AAEtC;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,OAAO;EACP,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;;;EAME,oBAAoB;EACpB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA,oBAAoB;;AAEpB;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0BAA0B;AAC1B;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* Subscription V5 */\n.BC-SubscriptionV5_NotifyBanner {\n  display: flex;\n  gap: 4px;\n  border-radius: 8px;\n  padding: 6px 8px 6px 4px;\n  align-items: start;\n  margin-bottom: 20px;\n}\n\n.BC-SubscriptionV5_NotifyBanner .text {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  align-items: center;\n  margin: auto 0;\n}\n\n.BC-SubscriptionV5_NotifyBanner > img {\n  padding: 3px;\n}\n\n.BC-SubscriptionV5_NotifyBanner .close-btn {\n  margin: auto;\n  margin-right: 4px;\n  width: 16px;\n  height: 16px;\n}\n\n.BC-SubscriptionV5_NotifyBanner .Polaris-Button__Content,\n.BC-SubscriptionV5_NotifyBanner .Polaris-Icon {\n  width: 11px;\n  height: 11px;\n}\n\n.BC-SubscriptionV5_NotifyInfo {\n  background: #e0f0ff;\n}\n\n.BC-SubscriptionV5_NotifySuccess {\n  background: #cdfee1;\n}\n\n.BC-SubscriptionV5_NotifyInfo .text {\n  color: #00527c;\n}\n\n.BC-SubscriptionV5_NotifySuccess .text {\n  color: #0c5132;\n}\n\n.BC-SubscriptionV5_NotifySuccess > img {\n  filter: brightness(0) saturate(100%) invert(39%) sepia(83%) saturate(353%) hue-rotate(101deg)\n    brightness(95%) contrast(92%);\n}\n\n.BC-SubscriptionV5_NotifyInfo .action {\n  color: #00527c;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.BC-SubscriptionV5_BillingPackage,\n.BC-SubscriptionV5_BillingInformation {\n  display: flex;\n  gap: 20px;\n}\n\n.BC-SubscriptionV5_BillingPackage > div,\n.BC-SubscriptionV5_BillingInformation > div {\n  padding: 20px;\n  border-radius: 8px;\n  width: 50%;\n}\n\n.BC-SubscriptionV5_BillingInformation > div:nth-child(2) {\n  background-color: #fafbfb;\n}\n\n.BC-SubscriptionV5_BillingInformation .plan-status {\n  background-repeat: no-repeat;\n  background-position-y: bottom;\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 25px;\n}\n\n.BC-SubscriptionV5_BillingPackage .plan-status .description,\n.BC-SubscriptionV5_BillingInformation .plan-status .description {\n  font-size: 14px;\n  margin-top: 8px;\n}\n\n.BC-SubscriptionV5_BillingPackage .plan-status.trial .selected .Polaris-Badge span,\n.BC-SubscriptionV5_BillingPackage .plan-status.trial .description,\n.BC-SubscriptionV5_BillingInformation .plan-status.trial .selected .Polaris-Badge span,\n.BC-SubscriptionV5_BillingInformation .plan-status.trial .description {\n  color: #5e4200;\n  font-weight: 500;\n}\n\n.BC-SubscriptionV5_BillingPackage .plan-status .Polaris-Badge--statusCritical,\n.BC-SubscriptionV5_BillingPackage .plan-status.expired .description,\n.BC-SubscriptionV5_BillingPackage .plan-status.exceeded .description,\n.BC-SubscriptionV5_BillingInformation .plan-status .Polaris-Badge--statusCritical,\n.BC-SubscriptionV5_BillingInformation .plan-status.expired .description,\n.BC-SubscriptionV5_BillingInformation .plan-status.exceeded .description {\n  color: #8e1f0b;\n  font-weight: 500;\n}\n\n.BC-SubscriptionV5_BillingPackage .plan-status .selected,\n.BC-SubscriptionV5_BillingInformation .plan-status .selected {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  margin-top: 10px;\n}\n\n.BC-SubscriptionV5_BillingPackage .plan-status .selected > p,\n.BC-SubscriptionV5_BillingInformation .plan-status .selected > p {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n}\n\n.BC-SubscriptionV5_BillingPackage .plan-status .selected .Polaris-Badge,\n.BC-SubscriptionV5_BillingInformation .plan-status .selected .Polaris-Badge {\n  border-radius: 8px;\n  padding: 2px 8px;\n  height: 20px;\n}\n\n.BC-SubscriptionV5_BillingPackage .plan-status .Polaris-Badge--statusWarning,\n.BC-SubscriptionV5_BillingInformation .plan-status .Polaris-Badge--statusWarning {\n  background-color: #ffea8a;\n  color: #4f4700;\n}\n\n.BC-SubscriptionV5_BillingPackage .plan-status .Polaris-Badge span,\n.BC-SubscriptionV5_BillingInformation .plan-status .Polaris-Badge span {\n  font-weight: 500;\n}\n\n.BC-SubscriptionV5_BillingPackage .plan-status .Polaris-Badge--statusSuccess,\n.BC-SubscriptionV5_BillingInformation .plan-status .Polaris-Badge--statusSuccess {\n  background-color: #cdfee1;\n  color: #0c5132;\n}\n\n.BC-SubscriptionV5_BillingInformation .info {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.BC-SubscriptionV5_BillingInformation .info .billing-header {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.BC-SubscriptionV5_BillingInformation .info .billing-header .management .Polaris-Icon span,\n.BC-SubscriptionV5_BillingInformation .info .billing-header .management .Polaris-Icon {\n  margin: unset;\n  width: 16px;\n  height: 16px;\n}\n\n.BC-SubscriptionV5_BillingInformation .info .billing-header .management {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #2c6ecb;\n  font-weight: 400;\n  cursor: pointer;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.BC-SubscriptionV5_BillingInformation .info .list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px; /* Gap between items */\n}\n\n.BC-SubscriptionV5_BillingInformation .info .list .item {\n  flex: 0 0 calc((100% - 12px) / 2); /* Allow exactly 3 items in a row, accounting for gaps */\n  gap: 4px;\n}\n\n.BC-SubscriptionV5_BillingInformation .info .list .item.underline > span {\n  border-bottom: 3px dotted #dfe3e8;\n}\n\n.BC-SubscriptionV5_BillingInformation .info .list .item > span {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #202223;\n}\n\n.BC-SubscriptionV5_BillingInformation .info .list .item > p {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 4px 0;\n}\n\n/* GMV detail modal */\n.BC-SubscriptionV5_GMVDetailModal {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.BC-SubscriptionV5_GMVDetailModal .gmv-table {\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.BC-SubscriptionV5_GMVDetailModal .gmv-table .gmv-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n}\n\n.BC-SubscriptionV5_GMVDetailModal .gmv-table .heading {\n  background-color: #fafbfb;\n  font-weight: 600;\n}\n\n.BC-SubscriptionV5_GMVDetailModal .gmv-table .gmv-row:not(:last-child) {\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.BC-SubscriptionV5_GMVDetailModal .gmv-table .gmv-row:last-child {\n  background-color: #f1f8f5;\n}\n\n.BC-SubscriptionV5_GMVDetailModal .gmv-table .footer .total > p {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: #005e46;\n}\n\n/* Container spacing */\n.BC-SubscriptionV5_ExplorePackages .slider-container {\n  position: relative;\n  width: 100%;\n  padding: 12px 20px;\n  border-radius: 8px;\n  background-color: #fafafa;\n}\n\n.BC-SubscriptionV5_ExplorePackages .slider-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n/* Wrap the slider for positioning tooltip */\n.BC-SubscriptionV5_ExplorePackages .slider-wrapper {\n  position: relative;\n}\n\n/* Tooltip styling */\n.BC-SubscriptionV5_ExplorePackages .slider-tooltip {\n  position: absolute;\n  top: 20px;\n  transform: translateX(-50%);\n  background: #ffffff;\n  box-shadow: 0px 2px 10px 0px #0000001a;\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 6px;\n  white-space: nowrap;\n}\n\n/* Labels under slider */\n.BC-SubscriptionV5_ExplorePackages .slider-labels {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 6px;\n  font-size: 13px;\n  color: #6b7280; /* gray-500 */\n}\n\n/* make the track thick and square, using Polaris variables (we set them inline in the wrapper) */\n.BC-SubscriptionV5_ExplorePackages .slider-container .Polaris-RangeSlider-SingleThumb__Input {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  background-color: transparent;\n  -webkit-appearance: none;\n  appearance: none;\n  position: relative;\n  z-index: 1;\n  background: #e1e3e5;\n  border-radius: 4px;\n  /* override track height & border-radius */\n  height: 6px !important; /* thick track */\n  overflow: visible;\n  background-repeat: no-repeat;\n  --pc-single-thumb-progress-lower: #008060;\n  --pc-single-thumb-progress-upper: transparent;\n  --pc-single-thumb-gradient-colors: var(--pc-single-thumb-progress-lower) 0%,\n    var(--pc-single-thumb-progress-lower) var(--pc-range-slider-progress),\n    var(--pc-single-thumb-progress-upper) var(--pc-range-slider-progress),\n    var(--pc-single-thumb-progress-upper) 100%;\n}\n\n/* Thumb element (Polaris separate element) */\n.BC-SubscriptionV5_ExplorePackages .slider-container .Polaris-RangeSlider-SingleThumb__Thumb {\n  background-color: #008060 !important;\n  border: 2px solid var(--pc-single-thumb-progress-lower) !important;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12) !important;\n}\n\n/* Make sure the focus ring looks nice */\n.BC-SubscriptionV5_ExplorePackages .slider-container .Polaris-RangeSlider-SingleThumb__Input:focus {\n  outline: none;\n}\n\n/* Firefox (sometimes needs -moz) */\n.BC-SubscriptionV5_ExplorePackages\n  .slider-container\n  .Polaris-RangeSlider-SingleThumb__Input::-moz-range-track {\n  height: 6px;\n  background: linear-gradient(\n    90deg,\n    var(--pc-single-thumb-progress-lower) 0%,\n    var(--pc-single-thumb-progress-lower) var(--pc-range-slider-progress),\n    var(--pc-single-thumb-progress-upper) var(--pc-range-slider-progress),\n    var(--pc-single-thumb-progress-upper) 100%\n  );\n}\n\n/* WebKit track fallback */\n.BC-SubscriptionV5_ExplorePackages\n  .slider-container\n  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-runnable-track {\n  height: 6px;\n  background: linear-gradient(\n    90deg,\n    var(--pc-single-thumb-progress-lower) 0%,\n    var(--pc-single-thumb-progress-lower) var(--pc-range-slider-progress),\n    var(--pc-single-thumb-progress-upper) var(--pc-range-slider-progress),\n    var(--pc-single-thumb-progress-upper) 100%\n  );\n}\n\n/* WebKit thumb fallback (if Polaris structure differs) */\n.BC-SubscriptionV5_ExplorePackages\n  .slider-container\n  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  background: #008060;\n  border: 2px solid var(--pc-single-thumb-progress-lower);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 32px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-header > div {\n  width: 50%;\n}\n\n.BC-SubscriptionV5_ExplorePackages .slider-header .Polaris-TextStyle--variationStrong {\n  font-weight: 500;\n}\n\n.BC-SubscriptionV5_ExplorePackages .slider-header .Polaris-TextStyle--variationPositive {\n  font-weight: 600;\n  color: #008060;\n  font-size: 16px;\n}\n\n/* Packages card */\n.BC-SubscriptionV5_ExplorePackages .packages {\n  display: flex;\n  gap: 16px;\n  margin-top: 40px;\n  align-items: stretch;\n}\n\n.BC-SubscriptionV5_ExplorePackages .enterprise_only {\n  background: #28a2b60d;\n  border-radius: 12px;\n  margin-top: 20px;\n  padding: 20px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .packages > div {\n  flex: 1;\n  border-radius: 12px;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card,\n.BC-SubscriptionV5_ExplorePackages .packages .package-card {\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card,\n.BC-SubscriptionV5_ExplorePackages .package-highlight-card,\n.BC-SubscriptionV5_ExplorePackages .recommended-card {\n  border: 1px solid #00a47c;\n  position: relative;\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-card .info {\n  padding: 56px 20px 20px;\n}\n\n.BC-Page__Package-ComparisonV5 .package-comparison-table .current-plan,\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-highlight-card .info,\n.BC-SubscriptionV5_ExplorePackages .package-highlight-card .info {\n  background: linear-gradient(\n    183.25deg,\n    rgba(40, 162, 182, 0.18) 2.69%,\n    rgba(76, 184, 121, 0) 97.31%\n  );\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-highlight-card .tag,\n.BC-SubscriptionV5_ExplorePackages .package-highlight-card .tag {\n  position: absolute;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #ffffff;\n  color: #005e46;\n  padding: 2px 8px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.BC-SubscriptionV5_ExplorePackages .recommended-card .tag {\n  position: absolute;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: linear-gradient(234.15deg, #008060 -7.36%, rgba(0, 128, 96, 0) 190.52%);\n  color: #ffffff;\n  padding: 2px 8px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .package-name,\n.BC-SubscriptionV5_ExplorePackages .package-card .package-name {\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 32px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .price,\n.BC-SubscriptionV5_ExplorePackages .package-card .price {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 44px;\n  text-align: center;\n  display: flex;\n  margin-top: 10px;\n  justify-content: center;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal\n  .downgrade-compare-container\n  .package-card\n  .price\n  .price-number,\n.BC-SubscriptionV5_ExplorePackages .package-card .price .price-number {\n  font-size: 44px;\n  line-height: 56px;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .price .per-month,\n.BC-SubscriptionV5_ExplorePackages .package-card .price .per-month {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  display: flex;\n  align-items: end;\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-card .price.disabled {\n  color: #8c9196;\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-card .select-product {\n  text-align: center;\n  margin-top: 10px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .packages .only-image img {\n  width: 100%;\n  height: auto;\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-card .Polaris-Button {\n  width: 100%;\n  margin-top: 24px;\n}\n.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .advances-package,\n.BC-SubscriptionV5_ExplorePackages .package-card .advances-package {\n  padding: 16px 20px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .advances-package > div,\n.BC-SubscriptionV5_ExplorePackages .package-card .advances-package > div {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .advances-package .line,\n.BC-SubscriptionV5_ExplorePackages .package-card .advances-package .line {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-card .advances-package .line img {\n  filter: brightness(0) saturate(100%) invert(28%) sepia(94%) saturate(546%) hue-rotate(116deg)\n    brightness(95%) contrast(96%);\n}\n.BC-SubscriptionV5_ExplorePackages .package-card .explore {\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  border-top: 1px solid var(--Colors-Border-border-secondary, #eaecf0);\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-card .explore:hover {\n  cursor: pointer;\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-card .explore .Polaris-Icon {\n  margin: unset;\n  width: 16px;\n  height: 16px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-card .explore > span {\n  font-weight: 500;\n}\n\n.BC-SubscriptionV5_ExplorePackages .enterprise-package-card {\n  background: linear-gradient(180deg, rgba(145, 233, 219, 0.1) 0%, rgba(140, 201, 234, 0.01) 100%);\n}\n\n.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .image {\n  padding: 24px 11px 20px;\n}\n.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .image img {\n  width: 100%;\n  height: auto;\n  max-width: 418px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .info {\n  padding: 0 32px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .need-more {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .label {\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 34px;\n  margin: 8px 0 4px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .description {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .enterprise-package-card .Polaris-Button {\n  width: 100%;\n}\n\n/* Brands that trust us + FAQs */\n.BC-SubscriptionV5_Brands {\n  padding: 32px 50px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.BC-SubscriptionV5-FAQs {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  padding: 32px 20px;\n}\n\n.BC-SubscriptionV5-FAQs .Polaris-Layout__Section--oneHalf {\n  flex: 1 1 24px;\n}\n\n.BC-SubscriptionV5-FAQs > .align-center,\n.BC-SubscriptionV5_Brands .align-center {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-width: 600px;\n  margin: auto;\n}\n\n.BC-SubscriptionV5-FAQs > .align-center .Polaris-Heading,\n.BC-SubscriptionV5_Brands .Polaris-Heading {\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 32px;\n  margin: 8px 0 4px;\n}\n\n.BC-SubscriptionV5_Brands .brand-items {\n  display: flex;\n  justify-content: space-around;\n  gap: 40px;\n}\n\n.BC-SubscriptionV5_Brands .brand-items img {\n  filter: brightness(0) drop-shadow(0 0 0.1px black);\n}\n\n.BC-SubscriptionV5_Brands .brand-items:nth-child(2) {\n  margin: 20px 50px;\n}\n\n.BC-SubscriptionV5-FAQs .Polaris-Stack__Item:first-child {\n  margin: unset;\n  padding: 20px;\n}\n\n.BC-SubscriptionV5-FAQs .Polaris-Stack__Item:nth-child(2) {\n  margin: unset;\n}\n\n.BC-SubscriptionV5-FAQs .Polaris-Stack__Item .BC_Card-Header {\n  max-width: 380px;\n  font-weight: 600;\n}\n\n.BC-SubscriptionV5-FAQs .Polaris-Card__Section:last-child {\n  padding-top: 0px;\n}\n\n.BC-SubscriptionV5-FAQs .Polaris-Card__Section ul {\n  margin: unset;\n  padding-left: 20px;\n}\n\n.BC-SubscriptionV5-FAQs .Polaris-Card__Header {\n  padding: var(--p-space-4) var(--p-space-4) 0;\n}\n/* End - Brands that trust us + FAQs */\n\n.BC-SubscriptionV5-DowngradeInfoModal .description {\n  padding-bottom: 20px;\n}\n.BC-SubscriptionV5-DowngradeInfoModal .description ul {\n  margin: unset;\n  padding-left: 21px;\n}\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container {\n  display: flex;\n  gap: 20px;\n}\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container > div {\n  flex: 1;\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .right {\n  border: 1px solid #e1e3e5;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .right .tag {\n  position: absolute;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #f1f2f3;\n  padding: 2px 8px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .info {\n  padding: 46px 20px 10px;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .right .info {\n  background: linear-gradient(\n    183.25deg,\n    rgba(223, 227, 232, 0.18) 2.69%,\n    rgba(223, 227, 232, 0) 97.31%\n  );\n}\n\n.Polaris-Modal-Dialog__Modal:has(.BC-SubscriptionV5-DowngradeInfoModal) {\n  max-width: 44rem;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .features {\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .feature .item {\n  display: flex;\n  flex-direction: column;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal\n  .downgrade-compare-container\n  .package-card\n  .features\n  .item\n  > div {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n  margin-left: 4px;\n  margin-top: 8px;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .package-card .action {\n  width: 100%;\n  padding: 20px;\n  margin-top: auto;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal\n  .downgrade-compare-container\n  .package-card\n  .action\n  .Polaris-Button {\n  width: 100%;\n}\n\n.BC-SubscriptionV5-DowngradeInfoModal .downgrade-compare-container .select-product {\n  text-align: center;\n  margin: 8px auto;\n}\n/* Subscribe Modal */\n\n.BC-SubscriptionV5_SubscribeModal > .description {\n  padding-bottom: 16px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .base-gmv {\n  display: flex;\n  align-items: start;\n  gap: 6px;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #e1e3e5;\n  margin-bottom: 16px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .base-gmv img {\n  width: 20px;\n  height: 20px;\n}\n.BC-SubscriptionV5_SubscribeModal .base-gmv .content > p:first-child {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .table-package-container {\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  gap: 20px;\n  padding: 16px;\n  border: 1px solid #e1e3e5;\n  background-color: #fafbfb;\n}\n\n.BC-SubscriptionV5_SubscribeModal .table-package-container .row {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-SubscriptionV5_SubscribeModal .table-package-container .row:nth-child(2) {\n  cursor: pointer;\n}\n\n.BC-SubscriptionV5_SubscribeModal .row > div:first-child {\n  width: 100%;\n}\n\n.BC-SubscriptionV5_SubscribeModal .row:not(:last-child) {\n  border-bottom: 1px dashed #c9cccf;\n  padding-bottom: 20px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .discount-code-info .Polaris-TextStyle--variationPositive,\n.BC-SubscriptionV5_SubscribeModal .row:not(:last-child) > div:nth-child(2) {\n  font-weight: 600;\n}\n\n.BC-SubscriptionV5_SubscribeModal .row:last-child {\n  align-items: center;\n}\n\n.BC-SubscriptionV5_SubscribeModal .row:last-child > div:last-child {\n  font-size: 20px;\n  font-weight: 700;\n  color: #003d2c;\n}\n\n.BC-SubscriptionV5_SubscribeModal .table-package-container .label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .table-package-container .label > p {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.BC-SubscriptionV5_SubscribeModal .table-package-container .label img {\n  width: 20px;\n  height: 20px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .table-package-container .info {\n  margin-top: 10px;\n  margin-left: 26px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .table-package-container .info > div {\n  display: flex;\n}\n\n.BC-SubscriptionV5_SubscribeModal .table-package-container .info > div .Polaris-Connected {\n  width: 345px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .table-package-container .info > div > span:first-child {\n  color: #6d7175;\n  min-width: 82px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .discount-code-info {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-right: -20px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .discount-code-info > div:first-child {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .discount-code-info .code-value {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: #f1f8f5;\n  border-radius: 4px;\n  padding: 4px 8px;\n}\n\n.BC-SubscriptionV5_SubscribeModal .discount-code-info .code-value .Polaris-Icon {\n  width: 14px;\n  height: 14px;\n  display: flex;\n}\n\n.BC-SubscriptionV5_SubscribeModal .discount-code-info .code-value .Polaris-Button__Icon {\n  display: flex;\n  justify-content: center;\n}\n\n/* Package Comparison */\n.BC-Page__Package-ComparisonV5 .package-comparison-table {\n  margin-top: 32px;\n}\n\n.BC-Page__Package-ComparisonV5 .title-bar {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 40px;\n  font-size: 26px;\n  line-height: 32px;\n}\n\n.BC-Page__Package-ComparisonV5 .choose-product-number {\n  font-size: 20px;\n}\n.BC-Page__Package-ComparisonV5 .choose-product-number .select-product {\n  margin: 0 auto;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n}\n\n.BC-Page__Package-ComparisonV5 .choose-product-number .select-product .Polaris-Select {\n  width: 150px;\n}\n.BC-Page__Package-ComparisonV5 .Polaris-Heading {\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 44px;\n  margin: 40px auto;\n}\n\n.BC-Page__Package-ComparisonV5 .package-comparison-table .price > span:first-child {\n  font-size: 36px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  text-align: center;\n}\n\n.BC-Page__Package-ComparisonV5 .package-comparison-table .current-plan .tag {\n  background-color: #ffffff;\n  color: #005e46;\n  padding: 2px 8px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.BC-Page__Package-ComparisonV5 .package-comparison-table .package-name {\n  margin-top: 24px;\n  margin-left: auto;\n  margin-right: auto;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  text-align: center;\n}\n\n.BC-Page__Package-ComparisonV5 .row-header .column-package {\n  padding: 20px !important;\n  gap: 0px !important;\n}\n\n.BC-Page__Package-ComparisonV5 .row-header .column-package > div:first-child {\n  min-height: 20px;\n  max-width: 113px;\n  margin: auto;\n}\n\n.BC-Page__Package-ComparisonV5 .row-header .column-package .price {\n  display: flex;\n  justify-content: center;\n  margin-top: 2px;\n}\n\n.BC-Page__Package-ComparisonV5 .row-header .column-package .price .per-month {\n  align-items: end;\n  display: flex;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.BC-Page__Package-ComparisonV5 .package-comparison-table .feature-collapse .action-collapse {\n  font-size: 16px;\n  line-height: 24px;\n  padding: 10px 24px;\n}\n\n.BC-Page__Package-ComparisonV5 .package-comparison-table .feature-collapse .action-collapse img {\n  width: 24px;\n  height: 24px;\n}\n\n/* GMV - Billing History */\n.BC-SubscriptionV5_GMVBillingHistory .BC-Page--heading > div,\n.BC-SubscriptionV5_GMVBillingHistory .BC-Page--heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.BC-SubscriptionV5_GMVBillingHistory .BC-Page--heading .filter-days .Polaris-Button {\n  background-color: #ffffff;\n}\n\n.BC-SubscriptionV5_GMVBillingHistory .gmv-history-table .Polaris-Card__Section {\n  padding: unset;\n}\n\n.BC-SubscriptionV5_GMVBillingHistory .gmv-history-table .no-data {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  padding: 80px;\n}\n\n.BC-SubscriptionV5_GMVBillingHistory .gmv-history-table tr th .Polaris-Labelled__LabelWrapper {\n  margin-bottom: 0;\n}\n\n.BC-SubscriptionV5_GMVBillingHistory .Polaris-DataTable__Cell--header p,\n.BC-SubscriptionV5_GMVBillingHistory .Polaris-DataTable__Cell--header span {\n  font-weight: 600;\n}\n\n.BC-SubscriptionV5_GMVBillingHistory .Polaris-DataTable__Cell--header .Polaris-Icon {\n  width: 10px;\n  height: auto;\n}\n\n.BC-SubscriptionV5_GMVBillingHistory\n  .Polaris-DataTable__Cell--header\n  .Polaris-Tooltip-TooltipOverlay__Content {\n  font-weight: 400;\n  text-align: left;\n}\n\n.BC-SubscriptionV5_GMVBillingHistory .Polaris-Page {\n  max-width: 1150px;\n}\n/* .BC-SubscriptionV5_GMVBillingHistory .pagination {\n  display: flex;\n  justify-content: center;\n} */\n\n.BC-SubscriptionV5_GMVBillingHistory .pagination .action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 24px;\n}\n\n.BC-SubscriptionV5_GMVBillingHistory .pagination .action .Polaris-Button:first-child {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n.BC-SubscriptionV5_GMVBillingHistory .pagination .action .Polaris-Button:last-child {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n.BC-SubscriptionV5_GMVBillingHistory .BC-GuideBanner__Content > div {\n  display: flex;\n  flex-direction: column;\n  padding: 6px 0;\n}\n\n.BC-SubscriptionV5_GMVBillingHistory .BC-GuideBanner__Content .BC-GuideBanner__Actions {\n  margin-top: auto;\n}\n\n.BC-Page__PackageSubscriptionV5 .package-layout {\n  max-width: 936px;\n  margin: 0 auto;\n}\n\n.BC-Page__PackageSubscriptionV5 .heading {\n  margin-top: 40px;\n  margin-bottom: 14px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  justify-content: center;\n  width: 100%;\n}\n\n.BC-Page__PackageSubscriptionV5 .heading h1 {\n  font-size: 26px;\n  font-weight: 600;\n  line-height: 32px;\n}\n\n.BC-Page__PackageSubscriptionV5 .heading p {\n  color: #6d7175;\n}\n\n.BC-Page__PackageSubscriptionV5 .Polaris-Layout__Section--oneHalf {\n  flex: 1 1 24px;\n}\n\n.BC-SubscriptionV5_BillingPackage .info {\n  background-color: #fafbfb;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.BC-SubscriptionV5_BillingPackage .info .billing-header {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.BC-SubscriptionV5_BillingPackage .info .billing-header > span {\n  border-bottom: 3px dotted #dfe3e8;\n}\n\n.BC-SubscriptionV5_BillingPackage .info .gmv {\n  font-size: 28px;\n  line-height: 32px;\n  font-weight: 600;\n}\n.BC-Page__PackageSubscriptionV5 .package-layout > .Polaris-Layout > .Polaris-Layout__Section {\n  margin-top: 32px;\n}\n\n.BC-Page__PackageSubscriptionV5 .BC-SubscriptionV5-FAQs > .align-center .Polaris-Heading {\n  margin-top: unset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
